import { PermissionsEnum } from "@/auth/interfaces";
import { ROUTER_PATHS, useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchSolicitudesEgreso, useFetchPutSolicitudPedito } from "@/shared/actions/erp";
import { GeneralTable } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { useTableSolicitudesPedido } from "@/shared/hooks/useTableSolicitudPedido";
import { EstadosSolicitudPeodidoEnum, } from "@/shared/interfaces";
import { SolicitudesEgreso } from "@/shared/interfaces/erp/compras/solicitudes-egreso.interface";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useUploadFile } from "@/shared";

interface SolicitudPedidoPageProps {
  estado: EstadosSolicitudPeodidoEnum;
  action?: boolean;
  tiene_rechazo?: boolean

}

const SolicitudPedidoTable = ({ estado, action = false, tiene_rechazo }: SolicitudPedidoPageProps) => {
  useCheckPermissions(PermissionsEnum.api_view_solicitudegreso)
  const navigate = useNavigate()
  //*store
  const Productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const paginationSample = useCargarSeriesProductos(s => s.pagination)
  const setPaginationSample = useCargarSeriesProductos(s => s.setPagination)

 //pdf 
   const {
    descargarPdfDesdeurl
  } = useUploadFile()


  const {
    mutateAsync: mutateAsyncPutSolicitudEgreso,    
  } = useFetchPutSolicitudPedito()


  const handleDescargarPdf = async (value:any, nameFile: string) => { 
    let url = value.url_pdf;
    if(!url){
      console.log("Ento aqui al if")
      try{
        const respuesta = await mutateAsyncPutSolicitudEgreso({
          id: value.id_solicitudegreso ? value.id_solicitudegreso : "",
        });
        if(respuesta.code !== 200 || !respuesta.data.url_pdf){
          toast.info('No existe documento. [404]');
          return;
        }
        url = respuesta.data.url_pdf;

      }catch (error){
        toast.info('No existe documento. [404]');
        return;
      }
    }
    descargarPdfDesdeurl(url, nameFile);
  }



  const {
    columns,
    isModalOpen,
    setIsModalOpen,
    //details,
    columnsProductosDetallePedidosDb
  } = useTableSolicitudesPedido({ estado, onDownload: handleDescargarPdf });


  const {
    searchTerm,
    pagination,
    setPagination,
  } = useTableFilter();


  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering();

 



  const {
    isLoading,
    data: dataSolicitudPedido,
    isRefetching,
  } = useFetchSolicitudesEgreso({
    page_size: pageSize,
    page: pageIndex + 1,
    estado_solicitud: estado,
    //*SEARCH
    numero_referencia: searchTerm,
    ...filterObject,
    filterByState: false,
    tiene_trazabilidad_rechazada: tiene_rechazo

  });
  const onEdit = (e:SolicitudesEgreso)=>{
    navigate(`${ROUTER_PATHS.pedidos.solicitud_pedidos_nav}/editar/${e.id_solicitudegreso}`)
  }


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<SolicitudesEgreso>
            columns={columns}
            data={dataSolicitudPedido?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataSolicitudPedido?.data.count}
            // // actions
            actionsColumnSize={120}
            // crud
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableManualFiltering={true}
            enableSorting={false}
            //editar
            positionActionsColumn="first"
            canEdit={true}
            canDelete={false}
            enableColumnActions={action}
            enableEditing={action}
            showCustomActionBtnSpace={true}
            onEdit={e=>{
              onEdit(e)
            }}
        
          />

        </Grid>
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Detalle Productos"
        cancelTextBtn="Cerrar"
        onCloseIcon={() => setIsModalOpen(false)}

        minWidth="65%"
        contentNode={
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <SampleTablePagination
                columns={columnsProductosDetallePedidosDb}
                data={paginatedData}
                pagination={paginationSample}
                setPagination={setPaginationSample}
                rowCount={Productos.length}
                rowNumber={true}
              />
            </Grid>
          </Grid>
        }
      />
    </>

  );

}

export default SolicitudPedidoTable;